import { BaseBus } from './BaseBus';
import { DateFunctions } from '../static/date-functions';

export class ReportOrderVendorCreditInfo extends BaseBus {
    constructor(dataObj: ReportOrderVendorCreditInfo = null) {
        super(dataObj);
        this.billDate = DateFunctions.getDate(dataObj.billDate);
        this.billCreated = DateFunctions.getDate(dataObj.billCreated);
        this.orderCreated = DateFunctions.getDate(dataObj.orderCreated);
        this.orderExpected = DateFunctions.getDate(dataObj.orderExpected);

        this.invoiceButtonStatus = "Not Available"
        if (this.invoiceId) {
            this.invoiceButtonStatus = "Created"
        }
        if (this.oracleInvoiceNumber && !this.invoiceId) {
            this.invoiceButtonStatus = "Available"
        }

    }
    supplierName: string;
    supplierLocationName: string;
    orderNumber: string;
    dispatchNumber: string;
    oracleSupplierid: string;
    buyerName: string;
    referenceNumber: string;
    receivedByName: string;
    poNumber: string;
    orderStatusName: string;
    orderBillStatusName: string;
    oracleInvoiceNumber: string;
    dispatchStatusName: string;
    customerName: string;
    locationName: string;
    orderId: string;
    orderBillId: string;
    dispatchId: string;
    billDate: Date;
    billCreated: Date;
    orderCreated: Date;
    orderExpected: Date;
    amountBilled: number;
    amountPaid: number;
    isSubContract: boolean;
    isConstruction: boolean;
    invoiceId: string;
    invoiceStatusName: string;
    invoiceNumber: string;
    invoiceButtonStatus: string;
}
